/**
 * Guards the one-shot reloads that recover a tab after a deploy.
 * Workbox matches `navigateFallbackDenylist` against pathname + search.
 */

export const CHUNK_RELOAD_STORAGE_KEY = "avante:chunk-reload-at";
export const SW_RELOAD_STORAGE_KEY = "avante:sw-reload-at";

/** A failed chunk must not reload in a tight loop. A later deploy can try again. */
export const RELOAD_GUARD_WINDOW_MS = 10_000;

export const ASSET_NAVIGATION_DENYLIST: RegExp[] = [/^\/assets(?:\/|$)/];

export type ReloadStorage = Pick<Storage, "getItem" | "setItem">;

export function isDeniedAssetNavigation(pathnameAndSearch: string): boolean {
  return ASSET_NAVIGATION_DENYLIST.some((pattern) =>
    pattern.test(pathnameAndSearch),
  );
}

/**
 * Returns true at most once per `windowMs`. Storage failures refuse the reload
 * so a broken sessionStorage cannot spin the page.
 */
export function claimReload(
  storage: ReloadStorage,
  key: string,
  now: number,
  windowMs = RELOAD_GUARD_WINDOW_MS,
): boolean {
  let previous: string | null;
  try {
    previous = storage.getItem(key);
  } catch {
    return false;
  }

  const last = previous === null ? Number.NaN : Number(previous);
  if (Number.isFinite(last) && now - last < windowMs) {
    return false;
  }

  try {
    storage.setItem(key, String(now));
  } catch {
    return false;
  }
  return true;
}
